
export enum SpaceType {
    Company = 1,
    Property = 2,
    Mixed = 3,
    Collaborative = 4
}
